import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from "@angular/core";
import { AddressSummaryService } from "@onsip/common/services/api/resources/addressSummary/address-summary.service";
import { views } from "@onsip/web/app/phone/views";

@Component({
  selector: "onsip-external-sip-address",
  templateUrl: "./external-sip-address.component.html",
  styleUrls: ["./external-sip-address.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ExternalSipAddressComponent implements OnInit {
  @HostBinding("class.onsip-admin-host-grid")
  @HostBinding("class.onsip-grid-content")
  _dontUse = true;
  views = views;

  constructor(private addressSummaryService: AddressSummaryService) {}

  ngOnInit(): void {
    this.addressSummaryService.addressSummaryBrowse();
  }
}
